import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'
import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/MAN.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'

import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG23 } from '../../../../../assets/deneme.svg'

import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'


import { ReactComponent as MySVG22 } from '../../../../../assets/TALLASIZEKIDS.svg'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as ZaraFscrr } from '../../../../../assets/waist/fscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/waist/fsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/waist/fsctmpaper.svg'

import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma
import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextKids from './DynamicTextKids'

import QRCodeComponent from './qrcodecomponent'
import RenderIndoItems from './RenderIndoItems'
import QRCodeComponent12 from './qrcodecomponent12mm'

import RenderIndoItemsKıds from './RenderIndoItemsKıds'
export default function Page2Kids({
  sizeData,
  selectColor = 0,
  barcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  bicakIzi
}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1) // Yatay daralma oranı (başlangıç 1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const selectedFscType = data.company?.fsctype;

  const FSC_COMPONENTS = {
    fscrr: { component: ZaraFscrr, width: "4.95mm", height: "7.8mm" },
    fsctm: { component: ZaraFsctm, width: "4.8mm", height: "7.724mm" },
    fsctmpaper: { component: ZaraFsctmpaper, width: "6.8mm", height: "9.504mm" },
  };
  const FSC_POSITIONS = {
    fscrr: { bottom: 83, left: 36.80, fontsize: "2.96px", fontweight: "normal" },
    fsctm: { bottom: 83, left: 37.80, fontsize: "2.96px", fontweight: "normal" },
    fsctmpaper: { bottom: 83.5, left: 40.30, fontsize: "3.59px", fontweight: 900 },
  };

  const SelectedComponent = FSC_COMPONENTS[selectedFscType];
  const position = FSC_POSITIONS[selectedFscType] || { 
    bottom: 27, 
    left: 36.80, 
    fontsize: "2.96px", 
    fontweight: "normal" 
  }; //


  // Bölmek için "/" karakterini kullan
  const [brand, category, subCategory] = department.split(' / ')
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])

  useEffect(() => {
    if (subCategory) {
      setCurrentShape(subCategory)
    }
    console.log("szrgrppppp",szrgrp)
  }, [subCategory])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };

  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak

  useEffect(() => {
    if (subCategory) {
      if (category === 'Woman') {
        if (subCategory === 'WOMAN') {
          settopValue(16);
          setleftValue(97.9)
      
        } else if (subCategory === 'PREMIUM DENIM') {
          settopValue(16);
          setleftValue(97.9)
       
        } else if (subCategory === 'CIRCULAR WOMAN') {
          settopValue(16);
          setleftValue(97.9)
      
        } else if (subCategory === 'BASIC') {
            settopValue(18);
         setleftValue(99.8)
     
        } else if (subCategory === 'TRF') {
           settopValue(16);
          setleftValue(92.4)
        } else {
  
        }
      } else if (category === 'Man') {
        if (subCategory === 'DENIMWEAR') {
            settopValue(16);
          setleftValue(92.4)
        } else if (subCategory === 'MAN') {
              settopValue(18);
          setleftValue(99.8)
        } else if (subCategory === 'GLOBAL') {
          settopValue(16);
          setleftValue(98)
      
        } else {
      
        }
      } else if (category === 'Kids') {
        if (subCategory === 'GIRL') {
          settopValue(16);
          setleftValue(97.9)
        } else if (subCategory === 'KIDS A (BABY GIRL)') {
           settopValue(16);
          setleftValue(97.9)
        } else if (subCategory === 'BABY UNIQUE' || subCategory === 'KNIT' || subCategory === 'DENIM' || subCategory === 'OUTERWEAR') {
          settopValue(7);
          setleftValue(90.5)
        } else if (subCategory === 'BOY') {
          settopValue(18);
          setleftValue(99.8)
       
        } else if (subCategory === 'KIDS O (BABY BOY)') {
          settopValue(18.1);
          setleftValue(99.6)
        } else {
  
        }
      } else {
   
      }
        
    }
  }, [subCategory]);
  
  
  const renderSVG = (integer3, decimal3, integer4, decimal4) => {
  
    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
    if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid:
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
   
  };
  
  
  

  const renderShape = (currentShape, category) => {
    if (category === 'Woman') {
      switch (currentShape) {
        case 'WOMAN':
          return (
            <MySVG11 
            style={{
              width: '9.4mm',
              height: '9.4mm',

            }}


          />
          )
        case 'PREMIUM DENIM':
      

          return (
            <MySVG11 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}

          />
          )
  
        case 'BASIC':
    
          return (
            <MySVG10 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )
        case 'TRF':
          return (
            <MySVG12 
            style={{
              width: '12.4mm',
              height: '10.4mm',
            }}
          />
          )
        default:
          return (
            <></>
          )
      }
    } else if (category === 'Man') {
      switch (currentShape) {
        case 'DENIMWEAR':
          return (
            <MySVG9 
            style={{
              width: '12.4mm',
              height: '10.4mm',
            }}
          />
          )

        case 'MAN':
          return (
            <MySVG7 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )

        case 'GLOBAL':
          return (
            <MySVG8 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )

        default:
          return (
           <></>
          )
      }
    } else if (category === 'Kids') {
      switch (currentShape) {
        case 'GIRL':
          return (
            <MySVG16 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )

        case 'KIDS A (BABY GIRL)':
          return (
            <MySVG14 
            style={{
              width: '9.4mm',
              height: '9.4mm',
            }}
          />
          )

        case 'BABY UNIQUE':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'KNIT':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'DENIM':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'OUTERWEAR':
          return (
            <MySVG17 
            style={{
              width: '13.4mm',
              height: '11.4mm',
            }}
          />
          )
        case 'BOY':
          return (
            <MySVG15 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )

        case 'KIDS O (BABY BOY)':
          return (
            <MySVG13 
            style={{
              width: '8.4mm',
              height: '8.4mm',
            }}
          />
          )

        default:
          return (
            <></>
          )
      }
    } else {
      // Eğer kategori ve alt kategori eşleşmiyorsa varsayılan bir şekil döndür
      return (
        <></>
      )
    }
  }
  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])



  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape


  return (
    <div>
      <div>
        <div>
          <div
            style={{
              position: 'absolute',
              top: -4.2,
              left: 8.2,

              justifyContent: 'center',
              display: 'grid',
              alignItems: 'center',
              textAlign: 'center'
            }}
          >
        
          </div>
          <div style={{


position: 'absolute',
top: '26px',
left: '107.5px',
zIndex:4
}}>
<ZaraBomRed width="4.4mm" height="4.4mm"></ZaraBomRed>
</div>
             <div
            style={{
              position: 'absolute',
              top: topValue,
              left: leftValue,
              display: 'flex', // Flexbox kullanımı
    justifyContent: 'center', // Yatayda ortalama
    alignItems: 'center', // Dikeyde ortalama
            }}
          >

      
          </div>

          <div style={{width:"144px",height:"0.5px",backgroundColor:"black",position:"absolute",top:76.4,left:45.4,zIndex:4}}></div>
          <div style={{width:"144px",height:"0.5px",backgroundColor:"black",position:"absolute",top:106.4,left:45.4,zIndex:4}}></div>
          <div></div>
   
   <div
            style={{
              position: 'absolute',
              top: SouthAmerica ? 214 : 228.6, // SouthAmerica true ise 270, değilse 288.6
              left: SouthAmerica ?76:67,
              flexDirection: 'column',
              display: 'grid'
            }}
          >
  {renderSVG(integerpart3, decimalpart3, integerpart4, decimalpart4)}
  {SouthAmerica && szrgrp.isbaby===true && (
            <div style={{width:"144px",height:"0.5px",zIndex:9999}}>
              <p className="helve-medium" style={{ fontSize: '5.24pt',fontWeight:600,letterSpacing:"0.3px",marginTop:-11,marginLeft:5.4}}>Manter longe do fogo</p>
            </div>
          )}
          </div>
          <div
            style={{
              position: 'absolute',
              top:  integerpart3 === '' ? 250 : 222.6, // Koşullu top değeri
              left: 119,
              flexDirection: 'column',
              display: 'grid'
            }}
          >
     
            <div style={{ display: 'grid' }}>
              <div style={{ display: 'grid' }}>
                {integerpart3 && (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
               
                      <p className="helve-medium" style={{ fontSize: '14pt' }}>
                        {integerpart3}
                      </p>
                      <p
                        className="helve-medium"
                        style={{ fontSize: '9pt', marginTop: '3px', marginRight: '4px' }}
                      >
                        {decimalpart3}
                      </p>
                    </div>
                    <div>
              
                    </div>
                  </>
                )}
              </div>
            </div>
            <div style={{ display: 'grid', marginTop: 4 }}>
            {integerpart4 && !SouthAmerica && (
                <>
  

                  <div style={{ display: 'flex', flexDirection: 'row' }}>
               
                    <p className="helve-medium" style={{ fontSize: '14pt' }}>
                      {integerpart4}
                    </p>
                    <p
                      className="helve-medium"
                      style={{ fontSize: '9pt', marginTop: '3px', marginRight: '4px' }}
                    >
                      {decimalpart4}
                    </p>
                  </div>
                  <div>
              
                  </div>
                </>
              )}
            </div>
          </div>


          <div
            style={{
              position: 'absolute',
              top: 69,
              left: 80,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: 75.2,
              
            }}
          >
         <MySVG19 width="19mm" height="1,359mm" ></MySVG19>
         </div>
       
      
       


          <div style={{ position: 'absolute', top: 0, right: 0 }}>
            <QRCodeComponent12  barcodeValue={barcodeValue}  onSvgGenerated={handleSvgGenerated} />
            {modifiedSvgText && (
              <div
  dangerouslySetInnerHTML={{ __html: modifiedSvgText }}

></div>

      )}
          </div>
          <DynamicTextKids
            filteredIndo={filteredIndo}
            inx={inx}
            szrgrp={szrgrp}
            valueBasedOnInx={valueBasedOnInx}
            referance={referance}
            brand={brand}
            category={category}
            subCategory={subCategory}
          />

           <div style={{position:"absolute",top:67.2,left:45.24}}>
           <MySVG22 width="38.1mm" height="10.664mm"></MySVG22>
           </div>
          <div ref={barcodeRef} className="tracking-[.02rem]" style={{ position: 'absolute', top: 167, left: 52.5,width:"35mm",height:"10.310mm"}}>
            <Barcode
              value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
              format="ITF14"
              width={0.936}
              height={25.9}
              marginLeft={1}
              marginRight={1}
              marginTop={1}
              marginBottom={1}
              background="transparent"
              lineColor={isBlack ? '#ffffff' : '#000000'}
              fontSize={9} // 7pt yaklaşık olarak 9px
              font="Helvetica Neue LT Std Roman"
            />
          </div>

          <div style={{ position: 'absolute', top: 112, left: 11,width:"95.5%" }}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

        <RenderIndoItemsKıds indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
          <div style={{ position: 'absolute', top: 134.4, left: 53.5 }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p className="helve-condensed" style={{ fontSize: '9pt', marginRight: '1px' }}>
                ART
              </p>  
              <p className="helve-condensed" style={{ fontSize: '9pt', marginRight: '8px' }}>
                .:
              </p>
              <p className="helve-condensed" style={{ fontSize: '9pt', marginLeft: '-7px' }}>
              {`${data.articleNo.replace('/', ' / ')} / ${data.priceLabel[selectColor].colorCode}`}
              </p>
              <div
          style={{
            height: '4mm',
            minWidth: '4mm',
            padding: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor:  'black' , // Ana indekse eşitse arka planı siyah yap
            color: "white",
            textAlign: 'center',
            marginLeft:7
          }}
        >
          <p className="helve-condensed" style={{ fontSize: '9pt', margin: 0,fontWeight:900 }}>
            {filteredIndo[inx]?.sCode|| ''}
          </p>
        </div>
            </div>{' '}
          </div>
        </div>
      </div>
    </div>
  )
}
